import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './globals.css'
import App from './App'
import logger from '@/lib/logging';
import { getRedirectCheckPromise } from '@/lib/auth-redirect-handler'

/**
 * True when the server injected real element markup (Node SSR or App Hosting).
 * Firebase Hosting SPA fallback keeps only the `<!--ssr-outlet-->` comment — that must
 * not hydrate (React #418) and should use a full client render instead.
 */
function hasRenderedSSRMarkup(root: HTMLElement): boolean {
  return root.querySelector(':scope > *') !== null
}

function renderApp() {
  const rootElement = document.getElementById('root')!

  const app = (
    <React.StrictMode>
      <BrowserRouter {...({ future: { v7_relativeSplatPath: true, v7_startTransition: true } } as object)}>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  )

  if (hasRenderedSSRMarkup(rootElement)) {
    logger.debug('🔄 Hydrating SSR content...')
    ReactDOM.hydrateRoot(rootElement, app)
  } else {
    logger.debug('🔄 Rendering app (no SSR content)...')
    ReactDOM.createRoot(rootElement).render(app)
  }
}

async function bootstrap() {
  // Capture OAuth redirect result before React mounts (redirect auth on localhost/mobile)
  await getRedirectCheckPromise()
  renderApp()
}

void bootstrap()
